import React from 'react';

import {useContentSidenavContext} from 'common/widgets/content-sidenav/context';
import {Content} from 'common/types/app-api/content';

import {usePinContent, UsePinContentParams} from './usePinContent';

// we have a separate WithSidenav hook because we use usePinContent in contentSidenavContext which would otherwise create a circular dependency
export function usePinContentWithSidenav({projectId, workspaceId, userId, source}: UsePinContentParams) {
  const contentSidenavContext = useContentSidenavContext();
  const pinContent = usePinContent({
    projectId,
    workspaceId,
    userId,
    source,
  });

  return React.useCallback(
    (content: Content) => {
      return pinContent(content, (result) => {
        contentSidenavContext?.updateSidenavSections({content: result});
      });
    },
    [pinContent, contentSidenavContext],
  );
}
